import {
    setCookie,
    initializeMap,
    initMenuTrigger,
    initOpenInNewTab,
    //aosConfig,
    addHideScrolledMenuClass,
    addFancyboxFixForGallery,
    initGallerySlider,
    addCloseCookies,
    initForm,
    googleMapInit,
    initLoadNews,
    faqService,
    initLazyBg,
    initLazyVideo,
    initMediaTextVideo,
    initShow,
    onClassChange,
    onElementShow,
    initCounting,
    initStickyCardStack
} from './functions';


import wcQuantity from './wcQuantity';

//import gsap from "gsap";


const mainApp = () => {

    // init lazy loading backgrounds width .lazyBg
    initLazyBg();

    // init lazy loading videos with .lazyVideo
    initLazyVideo();

    // play videos inside .wp-block-media-text when ~30% visible
    initMediaTextVideo();

    initShow();
    initShow('animDown', 'show');
    initShow('animRight', 'show');
    initShow('animLeft', 'show');

    // init counting animation for span.counting
    initCounting();

    // init menu trigger
    initMenuTrigger();

    // init open in new tab
    initOpenInNewTab();

    // init AOS animation config
    // aosConfig();

    // add scroll class to body  
    addHideScrolledMenuClass();



    //fix gallery id for slideshow
    addFancyboxFixForGallery('.wp-block-gallery');

    //gallerySlider
    initGallerySlider();

    // add close function to cookies
    addCloseCookies();



    //start - contact form
    initForm();

    googleMapInit();


    initLoadNews();

    faqService();

    // sticky cards stack effect - adds .small to previous card when next gets pinned
    initStickyCardStack();




}

document.addEventListener("DOMContentLoaded", mainApp, false);


(function ($) {
    const mainAppWithJquery = () => {


        $('.subpageHeader__goDown').click(function () {
            $('html,body').animate({ 'scrollTop': ($(this).offset().top - $(this).height()) + 'px' }, 500);
        });

        $('.gPlans .switchbox input').on('change', function () {
            if ($(this).is(':checked')) {
                $('.gPlans').addClass('quarter');
            } else {
                $('.gPlans').removeClass('quarter');
            }
        });


        $('.menu-item-has-children').on('click', function (e) {
            if (!$(this).hasClass('active')) {
                $(this).addClass('active');
            } else {
                $(this).removeClass('active');
            }
        })
        $('.menu-item a[href*="#"]').on('click', function (e) {
            $('body').removeClass('showMenu');
        });

        $('.subpageHeader__indexVideo video').on('playing', function () {
            $('body').addClass('video_loaded');
        });


        // add to cart
        $(document.body).on('added_to_cart', function (e, obj) {
            console.log(obj);
            $('.mainHeader__cartTotal').html(obj['cartTotal']).addClass('show');
            $('.miniCartContent').addClass('show');
            window.setTimeout(function () {
                $('.miniCartContent').removeClass('show');
            }, 3000);
        });

        //remove from cart
        $(document.body).on('removed_from_cart', (e, obj) => {
            $('.miniCartContent').html(obj['div.widget_shopping_cart_content']);
            $('.mainHeader__cartTotal').html(obj['cartTotal']);
        });
        // single page add to cart
        /*    $(document).on('click', '.single_add_to_cart_button', function (e) {
                e.preventDefault();
    
                var $thisbutton = $(this),
                    $form = $thisbutton.closest('form.cart'),
                    id = $thisbutton.val(),
                    product_qty = $form.find('input[name=quantity]').val() || 1,
                    product_id = $form.find('input[name=product_id]').val() || id,
                    variation_id = $form.find('input[name=variation_id]').val() || 0;
    
                var data = {
                    action: 'woocommerce_ajax_add_to_cart',
                    product_id: product_id,
                    product_sku: '',
                    quantity: product_qty,
                    variation_id: variation_id,
                };
    
                $(document.body).trigger('adding_to_cart', [$thisbutton, data]);
    
                $.ajax({
                    type: 'post',
                    url: wc_add_to_cart_params.ajax_url,
                    data: data,
                    beforeSend: function (response) {
                        $thisbutton.removeClass('added').addClass('loading');
                    },
                    complete: function (response) {
                        $thisbutton.addClass('added').removeClass('loading');
                    },
                    success: function (response) {
                        console.log(response);
                        if (response.error && response.product_url) {
                            window.location = response.product_url;
                            return;
                        } else {
                            $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);
                        }
                    },
                });
    
                return false;
            });
    */



        //add quantity buttons
        const quantityWc = new wcQuantity();

        $(document.body).on('updated_wc_div', () => {
            quantityWc.init();
            var alert = $('.woocommerce-notices-wrapper .woocommerce-error');
            if (alert.length > 0) {
                $('html,body').animate({ 'scrollTop': (alert.offset().top - 100) + 'px' }, 500);
            }



        });

        quantityWc.init();



        // Pole "Dla jakiej firmy?" w koszyku (inc/lo-listing-address.php).
        // Zapis do sesji lekkim AJAX-em (wc-ajax=lo_addr_save), bez przeladowania tabeli: wczesniej pole
        // klikalo "Zaktualizuj koszyk", a cart.js podmienial caly formularz i kasowal tekst wpisywany
        // w drugim polu. Zapisy ida po kolei (kolejka obietnic) - dwa rownolegle zadania nadpisywaly
        // sobie sesje koszyka. Fallback bez JS: "Zaktualizuj koszyk" / Enter wysyla formularz i tez zapisuje.
        // Przy Planie opieki pole ma wyszukiwarke wizytowki (data-search = endpoint lo-tools/v1/place-search):
        // link do Map albo "nazwa i miasto" -> lista kandydatow -> wybor zapisuje nazwe, adres i place_id.
        var loAddrQueue = $.Deferred().resolve().promise();

        function loAddrSave($input) {
            var value = $.trim($input.val());
            var placeId = String($input.attr('data-place-id') || '');
            if (value === String($input.attr('data-saved') || '') && placeId === String($input.attr('data-saved-place') || '')) {
                return;
            }
            var url = (typeof wc_cart_params !== 'undefined' && wc_cart_params.wc_ajax_url)
                ? String(wc_cart_params.wc_ajax_url).replace('%%endpoint%%', 'lo_addr_save')
                : '/?wc-ajax=lo_addr_save';
            $input.removeClass('saved').addClass('saving');
            var task = function () {
                return $.post(url, { key: $input.data('cart-id'), value: value, place_id: placeId, _wpnonce: $input.data('nonce') })
                    .done(function (res) {
                        if (res && res.ok) {
                            $input
                                .attr('data-saved', res.value)
                                .attr('data-saved-place', res.place_id || '')
                                .attr('data-place-id', res.place_id || '')
                                .val(res.value)
                                .addClass('saved');
                            if (res.all_filled) {
                                $('.lo-addr-notice').closest('.woocommerce-info, .woocommerce-message, .woocommerce-notice').slideUp(200);
                            }
                        }
                    })
                    .always(function () {
                        $input.removeClass('saving');
                    });
            };
            loAddrQueue = loAddrQueue.then(task, task);
        }

        $('body').on('change', '.adres_url', function () {
            loAddrSave($(this));
        });

        // Wyszukiwarka wizytowki Google przy Planie opieki
        var loFirmTimer = null;

        function loFirmList($input) {
            return $input.closest('.loFirm').find('.loFirm__results');
        }

        function loFirmHide($input) {
            loFirmList($input).empty().prop('hidden', true);
        }

        function loFirmSearch($input) {
            var q = $.trim($input.val());
            var endpoint = $input.attr('data-search');
            var $list = loFirmList($input);
            if (!endpoint || q.length < 3 || !$list.length) {
                return;
            }
            $list.prop('hidden', false).html('<li class="loFirm__info">Szukam wizytówki…</li>');
            $.getJSON(endpoint, { q: q })
                .done(function (items) {
                    if ($.trim($input.val()) !== q) {
                        return; // uzytkownik pisze dalej - odpowiedz nieaktualna
                    }
                    $list.empty();
                    if (!items || !items.length) {
                        $list.html('<li class="loFirm__info">Nie znaleźliśmy wizytówki. Dodaj miasto, wklej link z Map Google albo zostaw wpisany tekst.</li>');
                        return;
                    }
                    $.each(items, function (i, it) {
                        var $btn = $('<button type="button" class="loFirm__item"></button>')
                            .attr('data-place-id', it.place_id)
                            .attr('data-label', it.name + ', ' + it.address);
                        $('<span class="loFirm__name"></span>').text(it.name).appendTo($btn);
                        $('<span class="loFirm__addr"></span>').text(it.address).appendTo($btn);
                        $('<li></li>').append($btn).appendTo($list);
                    });
                })
                .fail(function () {
                    loFirmHide($input); // wyszukiwarka niedostepna - zostaje wolny tekst
                });
        }

        $('body').on('input', '.adres_url[data-search]', function () {
            var $input = $(this);
            $input.attr('data-place-id', ''); // reczna edycja uniewaznia wybrana wizytowke
            clearTimeout(loFirmTimer);
            loFirmTimer = setTimeout(function () {
                loFirmSearch($input);
            }, 500);
        });

        $('body').on('keydown', '.adres_url[data-search]', function (e) {
            if (e.key === 'Enter') {
                e.preventDefault(); // Enter szuka, zamiast wysylac formularz koszyka
                clearTimeout(loFirmTimer);
                loFirmSearch($(this));
            } else if (e.key === 'Escape') {
                loFirmHide($(this));
            }
        });

        // mousedown zamiast click: odpala sie przed blur pola, wiec po drodze nie zapisujemy samego tekstu
        $('body').on('mousedown', '.loFirm__item', function (e) {
            e.preventDefault();
            var $btn = $(this);
            var $input = $btn.closest('.loFirm').find('.adres_url');
            $input.val($btn.attr('data-label')).attr('data-place-id', $btn.attr('data-place-id'));
            loFirmHide($input);
            loAddrSave($input);
        });

        $(document).on('mousedown', function (e) {
            if (!$(e.target).closest('.loFirm').length) {
                $('.loFirm__results').empty().prop('hidden', true);
            }
        });



        // Modal rezygnacji z subskrypcji.
        // Celujemy w link anulowania WooCommerce Subscriptions, a nie w kontener, zeby modal
        // dzialal zarowno w szczegolach subskrypcji, jak i na liscie w Moim koncie (tam wczesniej
        // anulowanie szlo bez pytania o powod i bez oferty zatrzymujacej).
        var LO_CANCEL_LINK = 'a.cancel[href*="change_subscription_to=cancelled"]';

        function loSubIdFromUrl(url) {
            var match = /[?&]subscription_id=(\d+)/.exec(url || '');
            if (match) {
                return match[1];
            }
            // Zapas: na stronie szczegolow WCS udostepnia ID w zmiennej globalnej.
            return typeof WCSViewSubscription !== 'undefined' ? WCSViewSubscription.subscription_id : 0;
        }

        $('body').on('click', LO_CANCEL_LINK, function (e) {
            var $link = $(this);
            var url = $link.attr('href');
            var subId = loSubIdFromUrl(url);

            if (!subId) {
                return true; // nie wiemy, czego dotyczy - niech dziala zwykly link
            }

            // Biblioteka modala nie wstala (blokada sieci, wylaczony zasob): puszczamy zwykly
            // link WCS, zeby brak okna retencyjnego nigdy nie blokowal rezygnacji. Audyt T1-03.
            if (!$.fn.modal) {
                return true;
            }

            e.preventDefault();

            $.ajax({
                url: ajaxParams.ajaxurl + '?action=localone_cancel&sub=' + subId,
                error: function () {
                    window.location = url; // awaria admin-ajax - nie blokujemy rezygnacji
                },
                success: function (newHTML) {
                    var t = $(newHTML);

                    if (!t.length || !t.find('.modal__step.step1').length) {
                        window.location = url; // brak modala - nie blokujemy rezygnacji
                        return;
                    }

                    t.appendTo('body');
                    t.modal({
                        fadeDuration: 200,
                        fadeDelay: 1.0,
                        closeText: '',
                    });
                    t.on($.modal.AFTER_CLOSE, function () {
                        t.remove();
                    });

                    var $stepSwitch = t.find('.modal__step.stepSwitch');
                    var $step2 = t.find('.modal__step.step2');
                    var $step3 = t.find('.modal__step.step3');

                    function show($step) {
                        t.find('.modal__step').addClass('hide');
                        $step.removeClass('hide');
                    }

                    // Uchwyty zawezone do tego okna - inaczej dwa modale w DOM krzyzowalyby sie.
                    t.find('.cancel__cancel, .cancel__stayInPlan').on('click', function () {
                        $.modal.close();
                        return false;
                    });

                    // Link rezygnacji dziala od pierwszej chwili (powod pusty), zeby zadna sciezka
                    // okna nie konczyla sie martwym przyciskiem; powod dopisujemy, gdy klient go wybierze.
                    t.find('.cancel__finalCancel').attr('href', url);

                    t.find('input[name="cancel_question"]').on('change', function () {
                        var $checked = t.find('input[name="cancel_question"]:checked');
                        if (!$checked.length) {
                            return;
                        }
                        t.find('.cancel__step2').removeAttr('disabled');
                        t.find('.cancel__finalCancel').attr('href', url + '&cancel_reason=' + $checked.val());
                    });

                    t.find('.cancel__step2').on('click', function () {
                        // <a disabled> nie jest :disabled dla jQuery (to tylko atrybut), wiec
                        // sprawdzamy atrybut wprost. Test 25.09.2026, r03.
                        if (this.hasAttribute('disabled')) {
                            return false;
                        }
                        var reason = t.find('input[name="cancel_question"]:checked').val();
                        // Oferta tanszego planu tylko dla powodow wskazanych w ustawieniach.
                        var reasons = ($stepSwitch.data('reasons') || '').toString().split(',');
                        if ($stepSwitch.length && reasons.indexOf(reason) !== -1) {
                            show($stepSwitch);
                        } else if ($step2.length) {
                            show($step2);
                        } else {
                            show($step3);
                        }
                        return false;
                    });

                    t.find('.cancel__stepAfterSwitch').on('click', function () {
                        show($step2.length ? $step2 : $step3);
                        return false;
                    });

                    t.find('.cancel__step3').on('click', function () {
                        show($step3);
                        return false;
                    });

                    // Rabat retencyjny (tylko Plan opieki). Nonce przychodzi w przycisku
                    // razem z modalem - patrz lo-cancel-modal.php, audyt B3.
                    t.find('.cancel__want_discount').on('click', function () {
                        var nonce = $(this).data('nonce') || '';
                        $.ajax({
                            url: ajaxParams.ajaxurl + '?action=cancal_coupon&sub=' + subId + '&_wpnonce=' + encodeURIComponent(nonce),
                            success: function (raw) {
                                // wp_send_json wysyla application/json, wiec jQuery oddaje juz obiekt;
                                // JSON.parse na obiekcie rzucal i klient nie widzial potwierdzenia rabatu.
                                var response;
                                try {
                                    response = typeof raw === 'string' ? JSON.parse(raw) : raw;
                                } catch (err) {
                                    return;
                                }
                                if (!response) {
                                    return;
                                }
                                t.find('.modal__content.contentDiscoiunt').html(response.message);
                                if (response.status === 'coupon_added') {
                                    t.find('.cancel__want_discount, .cancel__step3').css('display', 'none');
                                }
                            },
                        });
                        return false;
                    });
                },
            });

            return false;
        });

        $('.signup-to-newsletter').on('change', function () {
            if ($(this).is(':checked')) {
                $(this).parents('.contactform').find('.gr-marketing-consent-checkbox').prop('checked', true);
            } else {
                $(this).parents('.contactform').find('.gr-marketing-consent-checkbox').prop('checked', false);
            }
        });














        //fancybox
        const fcbChck = document.querySelectorAll(".blocks-gallery-item a, .fancybox, .wp-block-image a[href$='.jpg'], .wp-block-image a[href$='.jpeg'], .wp-block-image a[href$='.png'], .wp-block-image.fancybox a");

        if (fcbChck.length > 0) {

            let scriptF = document.createElement("script");
            scriptF.setAttribute("src", window.location.origin + "/wp-content/themes/localone/plugins/fancybox/jquery.fancybox.min.js");
            document.body.appendChild(scriptF);
            let cssF = document.createElement("link");
            cssF.setAttribute("rel", 'stylesheet');
            cssF.setAttribute("href", window.location.origin + "/wp-content/themes/localone/plugins/fancybox/jquery.fancybox.min.css");
            document.body.appendChild(cssF);

            scriptF.addEventListener("load", () => {

                $(".blocks-gallery-item a, .fancybox, .wp-block-image a[href$='.jpg'], .wp-block-image a[href$='.jpeg'], .wp-block-image a[href$='.png'], .wp-block-image.fancybox a").fancybox({
                    'loop': true,
                    'margin': [44, 0],
                    'gutter': 50,
                    'keyboard': true,
                    'arrows': true,
                    'infobar': false,
                    'toolbar': true,
                    'buttons': ["slideShow", "fullScreen", "close"],
                    'idleTime': 4,
                    'protect': false,
                    'modal': false,
                    'animationEffect': "fade",
                    'animationDuration': 600,
                    'transitionEffect': "fade",
                    'transitionDuration': 800,
                    backFocus: false,
                    thumbs: {
                        autoStart: true, // Display thumbnails on opening
                        hideOnClose: true, // Hide thumbnail grid when closing animation starts
                        parentEl: ".fancybox-container", // Container is injected into this element
                        axis: window.innerWidth > 782 ? "y" : "x" // Vertical (y) or horizontal (x) scrolling
                    }
                });


            });



        }


        function toggleVatField() {
            var euCountries = ['AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GR', 'HR', 'HU', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PT', 'RO', 'SE', 'SI', 'SK'];
            var selectedCountry = $('#billing_country').val();
            if (euCountries.includes(selectedCountry)) {
                $('#billing_eu_vat_number_field').show();
            } else {
                $('#billing_eu_vat_number_field').hide();
                $('#billing_eu_vat_number_field').find('input').val('');
            }
        }

        toggleVatField();
        $('#billing_country').change(function () {
            toggleVatField();
        });




    };
    document.addEventListener("DOMContentLoaded", mainAppWithJquery, false);

    // Piksel Meta po zgodzie reklamowej w CookieYes (r04, 25.09.2026). Do zgody wtyczka
    // facebook-for-woocommerce trzyma sygnaly w stanie "held" (inc/lo-fb-consent.php). Po kliknieciu
    // zgody w banerze zwalniamy je oficjalnym API wtyczki (window.fbwcsignal), bez przeladowania strony.
    // Cofniecie zgody obsluguje skrypt w <head> przy nastepnej odslonie.
    document.addEventListener('cookieyes_consent_update', function (e) {
        var accepted = (e && e.detail && e.detail.accepted) || [];
        if (accepted.indexOf('advertisement') !== -1 && window.fbwcsignal && typeof window.fbwcsignal.release === 'function') {
            window.fbwcsignal.release();
        }
    });

})(jQuery);



